import {BaseService} from './Core/BaseService';
import {ObjectUtils} from "../Utils";
import {BaseSearchableService} from "./Core/BaseSearchableService";

class ContextNodeService extends BaseSearchableService {
    get Url() { return super.Url + "/contextNodes"; }
    get ModelName() { return "ContextNode"; }
    get PrimaryKeyProperty() { return "contextNodeId"; }
    get SearchProperties() { return ['name', 'shortName', 'nicknames', 'contextDescription']; }

    GetContextNode(id) {
        return this.SendRequest(BaseService.GET, id);
    }

    GetContextNodes(search) {
        let request = {name: search, recursive: true}
        return this.SendRequest(BaseService.GET, request, null, "", true);
    }

    Lookup({ programId, subProgramId, projectId, conservationActionId, sampleEventId, contextNodeTypeId }) {
        return this.SendRequest(BaseService.POST, { programId, subProgramId, projectId, conservationActionId, sampleEventId, contextNodeTypeId }, null, '/lookup');
    }

    GetChildrenContextNodes(context, search) {
        let request = ObjectUtils.Clone(context);
        
        if(search) {
            request.name = search;
        } else {
            request.name = "";
        }

        return this.SendRequest(BaseService.GET, request, null, "",true);
    }

    getContextNodeDescriptionByDepth(depth) {
        switch (depth) {
            case 1:
                return "program";
            case 2:
                return "sub-program";
            case 3:
                return "project";
            case 4:
                return "conservation action";
        }
        return "context";
    }

    GetEditabilityMessage(userRole, contextNodeDepth) {

        if(userRole == null) {
            return null;
        }

        var allowedEditDepth = null;
        var editDescription = null;

        if (userRole.code === 'super' || userRole.code === 'org_manager') {
            allowedEditDepth = 0
            return "Can view and edit all data for this organization."
        }

        if(userRole.code === 'auditor') {
            return "Can view limited data in this " + this.getContextNodeDescriptionByDepth(contextNodeDepth) + ".";
        } else if(userRole.code === 'viewer') {
            return "Can view all data in this " + this.getContextNodeDescriptionByDepth(contextNodeDepth) + ".";
        } else if(userRole.code === 'contributor') {
            allowedEditDepth = 4;
            editDescription = "conservation actions";
        } else if(userRole.code === 'proj_manager') {
            allowedEditDepth = 3;
            editDescription = "projects";
        } else if(userRole.code === 'prog_manager') {
            allowedEditDepth = 1;
            editDescription = "sub-programs";
        } else {
            return "Unexpected user role."
        }

        if(contextNodeDepth >= allowedEditDepth) {
            return "Can view and edit all data in this " + this.getContextNodeDescriptionByDepth(contextNodeDepth) + ".";
        } else {
            return "Can view all data in, and edit all " + editDescription + " of this " + this.getContextNodeDescriptionByDepth(contextNodeDepth) + ".";
        }

    }

    GetBenefitsSummary(contextNodeId, contextNodeTypeId = null, environmentalBenefitId = null, includeFunders = false) {
        if(contextNodeId == null) {
            return new Promise((resolve) => resolve(null) );
        }

        const urlSuffix = "/" + contextNodeId + "/benefits";
        const postData = {};
        if(environmentalBenefitId) {
            postData.environmentalBenefitId = environmentalBenefitId;
        }
        
        if(contextNodeTypeId) {
            postData.contextNodeTypeId = contextNodeTypeId;
        }
        
        if(includeFunders) {
            postData.includeFunders = true;
        }

        return this.SendRequest(BaseService.GET, postData, null, urlSuffix, true);
    }

	GetTitle(model, defaultTitle = "") {
        return model?.title ?? model?.header ?? defaultTitle;
    }
    
    GetShortTitle(model) {
        return model?.shortName ?? this.GetTitle(model);
    }
    
    GetSubtitle(model) {
        return model?.contextDescription;
    }

    SortModels(a, b, value) {
        let aContext = a.contextDescription ?? a.header;
        let bContext = b.contextDescription ?? b.header;
    
        if(aContext !== bContext) {
            return (aContext < bContext ? -1 : 1);
        } else if (a.header && !b.header) {
            return -1;
        } else if (!a.header && b.header) {
            return 1;
        } else {
            return (a.contextNodeId < b.contextNodeId ? 1 : -1);
        }
    }
}

export const service = new ContextNodeService();

